import React from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "primereact/button";
import Logo from "../../components/Logo/Logo";
import { API_BASE_URL } from "../../config";
import { logout } from "../../auth/session";
import { Screen, Card, Title, Text, Actions } from "./AuthError.styles";

interface AuthErrorProps {
  kind: "access-denied" | "login-error";
}

// Сюда сервер возвращает браузер, если вход не удался. Страница открывается без сессии,
// поэтому не обращается к API.
const AuthError: React.FC<AuthErrorProps> = ({ kind }) => {
  const [searchParams] = useSearchParams();
  const isBlocked = searchParams.get("reason") === "blocked";

  const title =
    kind === "login-error" ? "Не удалось войти" : "Нет доступа";

  const text =
    kind === "login-error"
      ? "Вход через ComradeMajor не завершился. Попробуйте ещё раз; если ошибка повторяется, обратитесь к администратору."
      : isBlocked
      ? "Ваша учётная запись заблокирована в CemLife RealTime. Обратитесь к администратору приложения."
      : "У вашей учётной записи нет доступа к этой установке CemLife RealTime. Доступ выдаёт администратор ComradeMajor.";

  const retry = () => window.location.assign(`${API_BASE_URL}/api/auth/login?returnUrl=%2F`);

  return (
    <Screen>
      <Card>
        <Logo />
        <Title>{title}</Title>
        <Text>{text}</Text>
        <Actions>
          <Button label="Попробовать снова" icon="pi pi-refresh" onClick={retry} />
          {kind === "access-denied" && (
            <Button
              label="Войти под другим пользователем"
              icon="pi pi-sign-out"
              outlined
              onClick={logout}
            />
          )}
        </Actions>
      </Card>
    </Screen>
  );
};

export default AuthError;
